@if (!commonQuestionnaireService.createMode) {
<div>
    @if (question.title) {
    <div class="title overflow-break-word full-width">
        <span>{{ question.number + 1 }}</span>
        <span [ngClass]="{ required: question.required && customerQuestionnaireService.displayVersion === 'full' }">
            {{ '. ' + question.title }}</span
        >
    </div>
    } @if (question.description) {
    <div class="description full-width m-t-5">
        {{ question.description }}
    </div>
    } @if (currentAnswer && currentAnswer[0]) {
    <div class="answer-body-container text-left full-width m-t-32">
        <mat-form-field
            appearance="outline"
            class="full-width"
        >
            <textarea
                maxlength="5000"
                rows="6"
                matInput
                [placeholder]="currentAnswer[0].placeholder"
                [(ngModel)]="currentAnswer[0].answer"
                (ngModelChange)="onAnswerChanged($event)"
                [disabled]="commonQuestionnaireService.reviewMode && questionReview?.notification_type !== 'modify'"
            ></textarea>
        </mat-form-field>
    </div>
    }
    <app-question-footer
        (questionMarked)="onQuestionMarked($event)"
        [questionIndex]="questionIndex"
        [showOk]="hasAnswer()"
        [question]="question"
    ></app-question-footer>
</div>
} @if (commonQuestionnaireService.createMode && question && currentAnswer) {
<div class="question-create-panel">
    @if (multilineForm) {
    <form [formGroup]="multilineForm.group">
        <div class="title no-border full-width">
            <div class="full-width input-form-field questionTitle m-t-10">
                @if (question.title) {
                <div class="title-number w-10-percent">
                    <mat-form-field
                        appearance="outline"
                        class="full-width title-input input-form-field"
                    >
                        <textarea
                            disabled
                            matInput
                            type="text"
                            class="title-textarea m-t-0 resize-none full-width"
                            >{{ questionTitle }}</textarea
                        >
                    </mat-form-field>
                </div>
                }
                <div class="m-l--10">
                    <mat-form-field
                        appearance="outline"
                        class="full-width title-input input-form-field"
                    >
                        <textarea
                            matInput
                            type="text"
                            class="title-textarea m-t-0"
                            #titleTextarea
                            [placeholder]="questionPlaceholder"
                            formControlName="title"
                            cdkTextareaAutosize
                            cdkAutosizeMinRows="1"
                            (ngModelChange)="onTitleChange()"
                            cdkAutosizeMaxRows="5"
                            required
                        ></textarea>
                        @if (TitleControl?.invalid && TitleControl?.touched) {
                        <mat-error>
                            <span>{{ multilineForm.getReadableError('title') }}</span>
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="description text-left fs-13 m-t-7 no-border full-width full-height">
            <mat-form-field
                appearance="outline"
                class="full-width input-form-field"
            >
                <textarea
                    matInput
                    type="text"
                    [placeholder]="descriptionPlaceholder"
                    formControlName="description"
                    class="description description-textarea"
                    cdkTextareaAutosize
                    maxlength="1000"
                    (ngModelChange)="onDescriptionChange()"
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="5"
                ></textarea>
            </mat-form-field>
        </div>
        @if (currentAnswer && currentAnswer[0]) {
        <mat-form-field
            appearance="outline"
            class="answer full-width"
        >
            <textarea
                type="text"
                class="font-italic text-left placeholder-textarea"
                maxlength="50"
                rows="3"
                matInput
                (ngModelChange)="onPlaceholderChange()"
                [placeholder]="answerPlaceholder"
                formControlName="placeholder"
            ></textarea>
        </mat-form-field>
        }
    </form>
    }
</div>
}
